import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';

/**
 * for this page
 */
import Nav from './nav';
import Slider from './slider';
import NewsList from './newsList';
import ExPlanWrapper from '../../../components/exPlanWrapper';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        console.log('content=', this.props);
        /**
         * 组件分发数据
         */
        const { content } = this.props;
        const { channelDesc } = content;

        return (
            <div className={styles.content}>
                {/* 头部广告 */}
                <div className={styles.ad_top} />
                <Nav searchData={content.search} />
                {content.slide ? <Slider content={content.slide} /> : null}
                {/* 正文部分 */}
                <div className={styles.mainBody}>
                    {/* 中部广告 */}
                    <div className={styles.ad_middle} />
                    <div className={styles.yc_m_l}>
                        {content.xjpNews ? (
                            <NewsList headLineNew={content.headLineNew} newsList={content.xjpNews} />
                        ) : (
                            <p style={{ textAlign: 'center', paddingTop: '30px' }}>暂无内容</p>
                        )}
                    </div>
                    <div className={styles.yc_m_r}>
                        {/* 右侧广告 */}
                        <div className={styles.ad_right} />
                        <div className={styles.mr_bom_box}>
                            {/* 频道介绍 */}
                            <Chip
                                id="50035"
                                type="struct"
                                title="新时代频道介绍"
                                groupName="侧边栏"
                                content={content.exclusivePlanning}>
                                <div className={styles.mr_intro}>
                                    <h3>{channelDesc.title}</h3>
                                    <img className={styles.intro_logo} src={channelDesc.logo} />
                                    <p className={styles.intro_p}>{channelDesc.description}</p>
                                    <img className={styles.intro_erwei} src={channelDesc.qrCode} />
                                    <p className={styles.erwei_p}>
                                        {channelDesc.qrCodeDesc1}
                                        <br />
                                        {channelDesc.qrCodeDesc2}
                                    </p>
                                </div>
                            </Chip>
                            <div className={styles.mr_rec}>
                                <h3>独家策划</h3>
                                <Chip
                                    id="55049"
                                    type="recommend"
                                    title="新时代独家策划"
                                    groupName="侧边栏"
                                    content={content.exclusivePlanning}
                                    translate="handlExclusivePlanningData">
                                    <ExPlanWrapper />
                                </Chip>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.foot_top_box}>
                    {/* 底部广告 */}
                    <div className={styles.ad_bottom} />
                </div>
            </div>
        );
    }
}

export default errorBoundary(Content);
